// Auth Actions
// action to denote user is currently attempting to login
export const AUTH_COMPONENT_LOGIN_USER_PENDING = '[Auth Component] LOGIN_USER_PENDING';
// action to denote login attempt for user resulted an error
export const AUTH_COMPONENT_LOGIN_USER_ERROR = '[Auth Component] LOGIN_USER_ERROR';
// action to denote login attempt of user was a success
export const AUTH_COMPONENT_LOGIN_USER_SUCCESS = '[Auth Component] LOGIN_USER_SUCCESS';
// action for loggin user out
export const AUTH_COMPONENT_LOGOUT_USER_SUCCESS = '[Auth Component] LOGOUT_USER_SUCCESS';
// action when the partner credential is rejected (401) — partner session only, DE/gateway untouched
export const AUTH_COMPONENT_PARTNER_SESSION_EXPIRED = '[Auth Component] PARTNER_SESSION_EXPIRED';
// action after user impersonation is error
export const AUTH_COMPONENT_USER_IMPERSONATION_ERROR = '[Auth Component] USER_IMPERSONATION_ERROR';
// action after user name is updated
export const AUTH_COMPONENT_UPDATE_USER_NAME = '[Auth Component] UPDATE_USER_NAME';
// action after user phone is updated
export const AUTH_COMPONENT_UPDATE_USER_PHONE = '[Auth Component] UPDATE_USER_PHONE';
// action after user email is updated
export const AUTH_COMPONENT_UPDATE_USER_EMAIL = '[Auth Component] UPDATE_USER_EMAIL';

export const AUTH_GLOBAL_SET_ISLOADING = '[Auth Component] SET_GLOBAL_ISLOADING';


// AUTH -- Partner

// action to denote login attempt of user was a success FOR PARTNER
export const AUTH_COMPONENT_LOGIN_USER_SUCCESS_PARTNER = '[Auth Component] LOGIN_USER_SUCCESS FOR_PARTNER';
export const AUTH_COMPONENT_INIT_LOGIN_USER_PARTNER_DETAILS = '[Auth Component] EXTRACT_LOGGED_IN_USER_INFO_FROM_TOKEN FOR_PARTNER';

/*

    The get user details and privileges are now bundled together
    separate actions are dispatch for setting each values
    but start and finish for them is together
    because they have to go in sync - both shall happen together
    to show for loading purposes on the UI

    the actions still sit under auth reducer and actions and service

*/

export const GLOBAL_COMPONENT_GET_USER_DETAILS_LOADING = '[Global Component] GET_USER_DETAILS_LOADING';
export const GLOBAL_COMPONENT_GET_USER_DETAILS_ERROR = '[Global Component] GET_USER_DETAILS_ERROR';

export const AUTH_COMPONENT_GET_USER_DETAILS_SUCCESS = '[Auth Component] GET_USER_DETAILS_SUCCESS';
// action for getting error in getting user details
export const AUTH_COMPONENT_GET_USER_DETAILS_ERROR = '[Auth Component] GET_USER_DETAILS_ERROR';

// Privileges for the user
// action to get privileges for user was a success
export const PRIVILEGES_FETCH_SUCCESS = '[Auth Component] PRIVILEGES_FETCH_SUCCESS';

// ========== CANDIDATE PAGE ===========
export const CANDIDATE_INITIALIZE = '[Candidate] INITIALIZE';
export const CANDIDATE_DESTROY = '[Candidate] DESTROY';

// Candidates
export const CANDIDATE_SET_CANDIDATES = '[Candidate] SET_CANDIDATES';
export const CANDIDATE_SET_CANDIDATE_RATING = '[Candidate] SET_CANDIDATE_RATING';
export const CANDIDATE_HIDE_CANDIDATE = '[Candidate] HIDE_CANDIDATES';

// Selected Ids
export const CANDIDATE_INSERT_SELECTED_IDS = '[Candidate] INSERT_SELECTED_IDS';
export const CANDIDATE_REMOVE_SELECTED_IDS = '[Candidate] REMOVE_SELECTED_IDS';
export const CANDIDATE_TOGGLE_SELECTED_ID = '[Candidate] TOGGLE_SELECTED_IDS';
export const CANDIDATE_INSERT_ALL_SELECTED_IDS = '[Candidate] INSERT_ALL_SELECTED_IDS';
export const CANDIDATE_CLEAR_SELECTED_IDS = '[Candidate] CLEAR_SELECTED_IDS';
export const CANDIDATE_TOGGLE_SELECTED_IDS_ALL = '[Candidate] TOGGLE_SELECTED_IDS_ALL';

// Candidates + SelectedId
export const CANDIDATE_SET_CANDIDATES_RATING = '[Candidate] SET_SELECTED_IDS_RATING';
export const CANDIDATE_HIDE_CANDIDATES = '[Candidate] HIDE_CANDIDATES';

// MODAL: Forward Candidate
export const CANDIDATE_OPEN_FORWARD_MODAL = '[Candidate] OPEN_FORWARD_MODAL';
export const CANDIDATE_CLOSE_FORWARD_MODAL = '[Candidate] CLOSE_FORWARD_MODAL';

// MODAL: Resume Modal
export const CANDIDATE_OPEN_RESUME_MODAL = '[Candidate] OPEN_RESUME_MODAL';
export const CANDIDATE_CLOSE_RESUME_MODAL = '[Candidate] CLOSE_RESUME_MODAL';

export const CANDIDATE_SET_CURSOR_ON_MODAL = '[Candidate] SET_CURSOR_ON_MODAL';
export const CANDIDATE_SET_CURSOR_LEFT_MODAL = '[Candidate] SET_CURSOR_LEFT_MODAL';

export const CANDIDATE_SET_CURSOR_ON_CANDIDATE = '[Candidate] SET_CURSOR_ON_CANDIDATE';
export const CANDIDATE_SET_CURSOR_LEFT_CANDIDATE = '[Candidate] SET_CURSOR_LEFT_CANDIDATE';

export const CANDIDATE_SET_ELEMENT_RECT = '[Candidate] CANDIDATE_SET_ELEMENT_RECT';

// Job Section

export const JOB_CREATE_EDIT_PRIVILEGES = '[Job] JOB_CREATE_EDIT_PRIVILEGES';

export const JOB_CREATE_EDIT_MODE = '[Job] JOB_CREATE_EDIT_MODE';

export const JOB_CREATE_EDIT_LOADING = '[Job] JOB_CREATE_EDIT_LOADING';
export const JOB_CREATE_EDIT_JOBGROUP_LOADING = '[Job] JOB_CREATE_EDIT_JOBGROUP_LOADING';
export const JOB_CREATE_EDIT_JOBGROUP_DETAIL_LOADING = '[Job] JOB_CREATE_EDIT_JOBGROUP_DETAIL_LOADING';
export const JOB_CREATE_EDIT_COMPANY_LOADING = '[Job] JOB_CREATE_EDIT_COMPANY_LOADING';

export const JOB_CREATE_EDIT_ORGANIZATION_ID = '[Job] JOB_CREATE_EDIT_ORGANIZATIONID';
export const JOB_CREATE_EDIT_COMPANY_ID = '[Job] JOB_CREATE_EDIT_COMPANYID';
export const JOB_CREATE_EDIT_JOB_GROUP_ID = '[Job] JOB_CREATE_EDIT_JOB_GROUP_ID';
export const JOB_CREATE_EDIT_JOB_HASH_ID = '[Job] JOB_CREATE_EDIT_JOB_HASH_ID';
export const JOB_CREATE_EDIT_JOB_TRAFFIC_TYPE = '[Job] JOB_CREATE_EDIT_JOB_TRAFFIC_TYPE';
export const JOB_CREATE_EDIT_JOB_CONFIDENTIAL = '[Job] JOB_CREATE_EDIT_JOB_CONFIDENTIAL';

export const JOB_CREATE_COMPENSATION_MODE = '[Job] JOB_CREATE_COMPENSATION_MODE';
export const JOB_CREATE_SET_END_DATE = '[Job] JOB_CREATE_SET_END_DATE'; // date dispatch through the drop down picker

export const JOB_CREATE_EDIT_ZIP = '[Job] JOB_CREATE_EDIT_ZIP';
export const JOB_CREATE_EDIT_CITY = '[Job] JOB_CREATE_EDIT_CITY';
export const JOB_CREATE_EDIT_STATE = '[Job] JOB_CREATE_EDIT_STATE';
export const JOB_CREATE_EDIT_SET_LATITUDE = '[Job] JOB_CREATE_EDIT_SET_LATITUDE';
export const JOB_CREATE_EDIT_SET_LONGITUDE = '[Job] JOB_CREATE_EDIT_SET_LONGITUDE';

export const JOB_CREATE_EDIT_TITLE = '[Job] JOB_CREATE_EDIT_TITLE';
export const JOB_CREATE_EDIT_DESCRIPTION = '[Job] JOB_CREATE_EDIT_DESCRIPTION';
export const JOB_CREATE_EDIT_INTERVIEW_QUESTIONS = '[Job] JOB_CREATE_EDIT_INTERVIEW_QUESTIONS';
export const JOB_REMOVE_INTERVIEW_QUESTION = '[Job] JOB_REMOVE_INTERVIEW_QUESTION';
export const JOB_CREATE_EDIT_REORDER_JOB_QUESTIONS = '[Job] JOB_CREATE_EDIT_REORDER_JOB_QUESTIONS';

export const JOB_CREATE_EDIT_RESET = '[Job] JOB_CREATE_EDIT_RESET';

export const JOB_CREATE_EDIT_SET_LOCATION_TYPE = '[Job] JOB_CREATE_EDIT_SET_LOCATION_TYPE';

// for the opening and closing the Filter on the page from anywhere
export const GLOBAL_FILTER_SET_OPEN = '[Global Filter] GLOBAL_FILTER_SET_OPEN';
export const GLOBAL_FILTER_SET_CLOSE = '[Global Filter] GLOBAL_FILTER_SET_CLOSE';
